module.exports = __webpack_public_path__ + "img/20190701160342266.58ff4f1b.png";